import useTranslation from '../../hooks/useTranslation';
import ChemicalDetailCropRates from '../ChemicalDetailCropRates';
import ChemicalDetailDocuments from '../ChemicalDetailDocuments';
import ChemicalDetailIngredients from '../ChemicalDetailIngredients';
import ChemicalDetailWeather from '../ChemicalDetailWeather';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';
import CaptionText from 'components/text/CaptionText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Optional label sections below the summary fields; each renders only when the
// enriched chemical carries data for it.
const ChemicalDetailSections: FunctionComponent<Props> = ({ chemical, testId = TEST_ID }) => {
    const { CAS_LABEL, CROP_RATES, DOCUMENTS, INGREDIENTS, PESTS, WEATHER_RESTRICTIONS } =
        useTranslation();

    return (
        <VerticalContainer className={styles.chemicalDetailSections} testId={testId}>
            {chemical?.ingredients && chemical.ingredients.length > 0 && (
                <ChemicalDetailIngredients
                    casLabel={CAS_LABEL}
                    ingredients={chemical.ingredients}
                    title={INGREDIENTS}
                />
            )}

            {chemical?.cropRates && chemical.cropRates.length > 0 && (
                <ChemicalDetailCropRates cropRates={chemical.cropRates} title={CROP_RATES} />
            )}

            {chemical?.weatherRestrictions && chemical.weatherRestrictions.length > 0 && (
                <ChemicalDetailWeather
                    title={WEATHER_RESTRICTIONS}
                    weatherRestrictions={chemical.weatherRestrictions}
                />
            )}

            {chemical?.documents && chemical.documents.length > 0 && (
                <ChemicalDetailDocuments documents={chemical.documents} title={DOCUMENTS} />
            )}

            {chemical?.pests && chemical.pests.length > 0 && (
                <VerticalContainer>
                    <BodyText text={PESTS} />

                    <CaptionText text={chemical.pests.join(', ')} />
                </VerticalContainer>
            )}
        </VerticalContainer>
    );
};

export default ChemicalDetailSections;
